import { api } from '@cma/app'
import {
  DestroyBrandingMutation,
  DestroyBrandingMutationVariables
} from '@cma/generated/graphql'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { gql } from 'graphql-request'

export function useDestroyBranding() {
  const queryClient = useQueryClient()

  return useMutation<
    DestroyBrandingMutation,
    Error,
    DestroyBrandingMutationVariables
  >(
    (variables) => {
      const query = gql`
        mutation DestroyBranding($id: ID!) {
          destroyBranding(id: $id) {
            success
            errors {
              field
              message
            }
          }
        }
      `
      return api<DestroyBrandingMutation, DestroyBrandingMutationVariables>({
        query,
        variables
      })
    },
    {
      async onSuccess() {
        await queryClient.invalidateQueries(['platformClient'])
      }
    }
  )
}
